<template>
  <v-navigation-drawer v-model="drawer"
                       app
                       fixed
                       disable-resize-watcher
                       color="bars"
                       dark
                       class="NavigationDrawer"
                       v-bind="$attrs"
                       style="font-family: Arial, sans-serif !important;">
    <template v-slot:prepend>
      <div class="pa-2 d-flex justify-center">
        <v-img src="/v2/images/mobilelocker_logo_white.png"
               max-height="48"
               max-width="203"
               contain/>
      </div>
      <div class="text-center white--text overline text-uppercase font-weight-bold"
           style="font-family: Arial, sans-serif !important;">
        Administration
      </div>
    </template>

    <v-list dense
            nav>
      <template v-if="isAuthenticated">
        <v-list-item :to="{name: 'library.home'}"
                     target="_blank">
          <v-list-item-icon>
            <v-icon small>
              fas fa-fw fa-books
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              My Content Library
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item v-if="canEditPresentations"
                     href="/admin/presentations">
          <v-list-item-icon>
            <v-icon small>
              fas fa-fw fa-presentation
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Presentations
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="presentationJobs.length">
            <v-icon color="success">
              fas fa-spin fa-spinner
            </v-icon>
          </v-list-item-action>
        </v-list-item>

        <template v-if="isAdmin">

          <v-list-item v-if="canEditFolders"
                       href="/admin/folders">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-folder
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Folders
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item :to="{name: 'admin.labels.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-tags
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Labels
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="team.mailgun_enabled && canEditEmailTemplates">
            <v-list-item :to="{name: 'admin.mailgun_messages.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-inbox
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Emails
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'admin.share_templates.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-envelope
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Email Templates
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'admin.neverbounce.email_lists.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-check-square
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold d-flex align-center">
                  <div class="me-2">
                    Clean Email Lists
                  </div>
                  <v-chip color="success"
                          x-small
                          label>
                    NEW
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canTestEmailTemplates"
                         :to="{name: 'admin.mailgun.email_previews'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-lightbulb
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold d-flex align-center">
                  <div class="me-2">
                    Email Previews
                  </div>
                  <v-chip color="success"
                          x-small
                          label>
                    NEW
                  </v-chip>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item v-if="canUseSinch"
                       :to="{name: 'admin.sinch_templates.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-comments
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Text Message Templates
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canUseMetabase"
                       @click.stop="openMetabase"
                       href="#">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-chart-line
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Metabase
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditUsers"
                       href="/admin/users">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-user
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Users
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditGroups"
                       :to="{name: 'admin.groups.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-users
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Groups
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditUserContacts"
                       :to="{name: 'admin.user_contacts.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-address-book
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Contacts
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditTerritories"
                       :to="{name: 'admin.territories.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-map
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Territories
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="canEditFiles">
            <v-list-item :to="{name: 'admin.team_assets.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-copy
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Public Files
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="canEditPresentations">
            <v-list-item :to="{name: 'admin.shared_links.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-share-alt
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Shared Links
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="canUserCreateSpaces">
            <v-list-item :to="{name: 'admin.spaces.index'}">
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-cabinet-filing
                </v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Spaces
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item v-if="faxingEnabled && canEditFaxes"
                       :to="{name: 'admin.fax.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-fax
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Faxes
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditForms"
                       href="/admin/forms">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-file-alt
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Forms
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditMessages"
                       href="/admin/messages">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-comment-dots
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Team Messages
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditBrands"
                       :to="{name: 'admin.brands.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-store
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Brands
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="team && team.presentation_disclaimers_enabled && canEditPresentations"
                       :to="{name: 'admin.disclaimers.index'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-exclamation-triangle
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Disclaimers
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditProducts"
                       :to="{name: 'admin.products'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-list
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Products
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canEditEvents"
                       href="/admin/events">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-calendar-alt
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Trade Shows/Events
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="canScanBusinessCards"
                       href="/admin/cards">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-address-card
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Business Cards
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <template v-if="team.veeva_vault_enabled && canEditPresentations">
            <v-list-item :to="{name: 'vv.import.wizard'}">
              <v-list-item-icon>
                <v-img src="/v2/images/veeva/veeva-vault-1.png"
                       width="24"
                       height="24"
                       alt="Veeva Vault"/>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Veeva Vault
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <template v-if="team.pepper_flow_enabled && canEditPresentations">
            <v-list-item :to="{name: 'admin.pf.import.wizard'}">
              <v-list-item-icon>
                <v-img src="/v2/images/vodori/favicon-1-300x300.png"
                       width="24"
                       height="24"
                       alt="Pepper Flow"/>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Vodori Pepper Flow
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

          <v-list-item v-if="1===2 && team.id === 65"
                       :to="{name: 'admin.incyte.sampling.orders'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-list
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Incyte CSOs
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="team.id === 211 && canEditSubscribers"
                       :to="{name: 'avion.formsite.unsubscribe'}">
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-user-minus
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                FormSite Unsubscribes
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item v-if="teams.length > 0"
                       :to="{name: 'admin.teams.index'}"
                       exact>
            <v-list-item-icon>
              <v-icon small>
                fas fa-fw fa-repeat
              </v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                Switch Teams
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group color="white">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-building
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Team Settings
              </v-list-item-title>
            </template>

            <v-list-item v-if="canEditTeam"
                         href="/admin/team/edit">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Edit Team
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canEditTeam"
                         :to="{name: 'subscription'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Billing
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canEditMetabasePermissions"
                         :to="{name: 'admin.metabase.users'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Metabase Users
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canEditSubscribers"
                         :to="{name: 'admin.subscribers.index'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Subscribers
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="isEmployee && team.sso_enabled"
                         :to="{name: 'admin.team_domains.index'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  SSO Domains
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="isEmployee"
                         :to="{name: 'admin.meilisearch.dashboard'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Meilisearch
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item v-if="canTeamUseSinch"
                         :to="{name: 'admin.sinch_configurations.index'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Text Message Configuration
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

          </v-list-group>

          <v-list-group v-if="isEmployee"
                        color="white">
            <template v-slot:activator>
              <v-list-item-icon>
                <v-icon small>
                  fas fa-fw fa-cogs
                </v-icon>
              </v-list-item-icon>
              <v-list-item-title>
                Employees
              </v-list-item-title>
            </template>

            <v-list-item :to="{name: 'admin.apple.updates_file'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  iOS App Configuration File
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'admin.employees.mailgun.domains'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Mailgun Domains
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'admin.email_addresses.search'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  Override Email Addresses
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="{name: 'admin.team.create'}">
              <v-list-item-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  New Team
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-group>

        </template>
      </template>
    </v-list>

    <template v-slot:append>
      <v-list v-if="isAuthenticated"
              dense
              nav>
        <v-divider></v-divider>
        <HelpMenuItem>
        </HelpMenuItem>
        <v-list-item href="https://help.mobilelocker.com/article/319-mobile-locker-change-log"
                     target="_blank">
          <v-list-item-icon>
            <v-icon small>
              fas fa-fw fa-list
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Change Log
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item href="/admin/presentations">
          <v-list-item-icon>
            <v-icon small>
              fas fa-fw fa-cogs
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Administration v1
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click.prevent="logout">
          <v-list-item-icon>
            <v-icon small>
              fas fa-fw fa-sign-out
            </v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Sign Out
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </template>
  </v-navigation-drawer>
</template>
<script>
import {mapGetters} from 'vuex';
import HelpMenuItem from './HelpMenuItem';
import metabaseService from '../services/metabaseService';

export default {
  components: {HelpMenuItem},
  data() {
    return {
      mini: false,
      teamSettings: false,
    }
  },
  computed: {
    ...mapGetters([
      'canEditBrands',
      'canEditEmailTemplates',
      'canEditEvents', // MLD-6878
      'canEditFaxes',
      'canEditFiles',
      'canEditFolders',
      'canEditForms',
      'canEditGroups',
      'canEditLabels',
      'canEditMessages',
      'canEditMetabasePermissions',
      'canEditPresentations',
      'canEditProducts',
      'canEditSubscribers',
      'canEditTeam',
      'canEditTerritories',
      'canEditUserContacts',
      'canEditUsers',
      'canScanBusinessCards', // MLD-6878
      'canSendEmails',
      'canSendFaxes',
      'canVerifyEmails', // MLD-6016
      'isAuthenticated',
      'canUseMetabase',
      'canUserCreateSpaces', // MLD-4908
      'canUseSinch', // MLD-7490
      'canTeamUseSinch', // MLD-7490
      'canTestEmailTemplates', // MLD-4550
      'faxingEnabled',
      'isAdmin',
      'isEmployee',
      'presentationJobs',
      'team',
      'teams',
      'user',
    ]),
    drawer: {
      get() {
        return this.$store.state.system.drawer
      },
      set(val) {
        this.$store.commit('setDrawer', val)
      },
    },
  },
  created() {
    this.initMenu();
  },
  methods: {
    initMenu() {
      if ((this.$route.name && this.$route.name.includes('team'))
        || this.$route.path.includes('/team')) {
        this.teamSettings = true;
      }
    },
    async logout() {
      await this.$store.dispatch('logout');
    },
    toggleTeamSettings() {
      this.teamSettings = !this.teamSettings;
    },
    async openMetabase(e) {
      try {
        e.preventDefault();
        await metabaseService.openMetabase();
      } catch (e) {
        this.$toast.error('You cannot access Metabase.');
        console.log(e);
      }
    }
  }
}
</script>
